import React, { Component } from 'react';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        newPassword: "",
        newPasswordConfirm: "",
        token: this.props.match.params.token,
      },
    };
  }

  componentDidMount = () => {
    this.validateToken();
  }

  validateToken = () => {
    fetch(
      '/api/validatePasswordResetToken',
      {
        method: "POST",
        body: JSON.stringify({token: this.state.initialValues.token}),
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (!res.ok) {
        window.location.href = "/";
      }
    })
  }

  submit = (values, actions) => {
    fetch('/api/resetPassword', {
      method: "POST",
      body: JSON.stringify(values),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
    })
    .then(res => {
      if (!res.ok) {
        alert("Could not reset password");
      } else {
        alert("Password resetted successfully");
        window.location.href = "/";
      }
    })
    .catch(error => console.log(error))
    .then(() => actions.setSubmitting(false));
  }

  validationSchema = () => {
    return Yup.object()
      .shape({
        newPassword: Yup.string()
          .required("Required!")
          .min(8, "Too short!")
          .max(128, "Too long!"),
        newPasswordConfirm: Yup.string().ensure()
          .when('newPassword', {
            is: (newPassword) => newPassword,
            then: Yup.string().oneOf([Yup.ref("newPassword")], "Passwords do not match"),
            otherwise: null
          })
      })
  }

  render() {
    return (
      <div id = "wrapper">
        <div className="limiter">
          <div className="container-login100">
            <div className="wrap-login100 p-l-85 p-r-85 p-t-55 p-b-55">
              <Formik initialValues={this.state.initialValues} onSubmit={this.submit} validationSchema={this.validationSchema()}>
                {
                  (props) => {
                    return (
                      <form className="login100-form validate-form flex-sb flex-w" onSubmit={props.handleSubmit}>
                        <div className="m-b-36" style={{width: "100%"}}>
                          <span className="txt1 m-b-11" style={{display: "block"}}>
                            New Password
                          </span>
                          <div className="wrap-input100 validate-input">
                            <Field autoFocus className="input100" type="password" name="newPassword" />
                            <span className="focus-input100"></span>
                          </div>
                          <ErrorMessage name="newPassword" component="div" style={{display: "block"}} className="errorMessage"/>
                        </div>

                        <div className="m-b-36" style={{width: "100%"}}>
                          <span className="txt1 p-b-11" style={{display: "block"}}>
                            Confirm Password
                          </span>
                          <div className="wrap-input100 validate-input">
                            <Field className="input100" type="password" name="newPasswordConfirm" />
                            <span className="focus-input100"></span>
                          </div>
                          <ErrorMessage name="newPasswordConfirm" component="div" style={{display: "block"}} className="errorMessage"/>
                        </div>

                        <button 
                          type="submit"
                          className="btn btn-primary"
                          style={{margin: "0px", width: "100%"}}
                        >
                          Reset Password
                        </button>
                      </form>
                    )
                  }
                }
              </Formik>
            </div>
          </div>
        </div>
        <div id="dropDownSelect1"></div>
      </div>
    );
  }
}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/Components/ResetPassword.js